import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { FileUploadModule } from 'ng2-file-upload';

import { ClienteUnidadeNegocioImportModalComponent } from './cliente-unidade-negocio-import-modal.component';

@NgModule({
    imports: [
        SharedModule,
        FileUploadModule
    ],
    declarations: [
        ClienteUnidadeNegocioImportModalComponent
    ],
    exports: [
        ClienteUnidadeNegocioImportModalComponent
    ]
})
export class ClienteUnidadeNegocioImportModalModule { }
